module.exports = __webpack_public_path__ + "img/DSC_1431.b37c87de.jpg";